import { Stack, type StackProps, styled } from '@mui/material';

export const StyledStack = styled(Stack)<StackProps>(({ theme }) => ({
  width: '100%',
  minWidth: 0,
  overflowX: 'hidden',
  flexWrap: 'wrap',
  gap: theme.spacing(1),
  marginBottom: theme.spacing(2),
  paddingBottom: theme.spacing(0.5),
  '&::-webkit-scrollbar': {
    width: theme.spacing(0.4),
    height: theme.spacing(0.4),
  },
  '&::-webkit-scrollbar-track': {
    WebkitBoxShadow: theme.shadows[0],
  },
  '&::-webkit-scrollbar-thumb': {
    backgroundColor: theme.palette.grey[300],
    outline: `1px solid ${theme.palette.grey[300]}`,
  },
}));
